module.exports = __webpack_public_path__ + "img/logo.0d3e393b.png";